/**
 * PostCreateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * PostCreateReq
 */
export interface PostCreateReq {
  /** 帖子标题 */
  title?: string
  /** 帖子内容 */
  content: any
  /** 发布者用户ID（为空则使用官方账号） */
  author_id?: any
  /** 文件ID列表 */
  file_ids?: string[]
}

/**
 * PostCreateReq Schema
 */
export const PostCreateReqSchema: SchemaDefinition = {
  properties: {
    title: {
      description: '帖子标题',
      format: 'string',
      type: 'string',
      label: '帖子标题',
    },
    content: {
      description: '帖子内容',
      format: 'string',
      type: 'text',
      label: '帖子内容',
    },
    author_id: {
      description: '发布者用户ID（为空则使用官方账号）',
      format: 'string',
      type: 'user',
      label: '发布者用户ID',
    },
    file_ids: {
      description: '文件ID列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: '文件ID列表',
    },
  },
  required: ['content'],
  type: 'object',
}
